<template>
<div>
  <div class="wph-flex wph-items-baseline wph-mb-4 wph-py-4 wph-border-b wph-border-gray-200">
    <cart-item-breadcrumbs
      :product-type="localType"
      @product-type-reset="onTypeReset"
    ></cart-item-breadcrumbs>
    <div v-if="editedCartItem" class="wph-hidden md:wph-block wph-ml-auto wph-pl-6 wph-text-center">
      <button @click="onPickCancel" class="wph-button wph-button--secondary wph-button--small wph-border-red-lighter wph-text-red-light wph-text-sm">Отмена</button>
    </div>
  </div>
  <textile-type-picker-simple v-if="!localType" v-model="localType" />
  <textile-model-picker v-if="localType" :product-type="localType" @input="onModelPick" />
  <div v-if="editedCartItem" class="md:wph-hidden wph-text-center">
    <button @click="onPickCancel" class="wph-button wph-button--secondary wph-border-red-lighter wph-text-red wph-text-sm">Отмена</button>
  </div>
</div>
</template>

<script>import CartItemBreadcrumbs from './CartItemBreadcrumbs'
import TextileTypePickerSimple from './TextileTypePickerSimple'
import TextileModelPicker from './TextileModelPicker'

export default {
  name: "ProductPicker",
  components: {
    CartItemBreadcrumbs,
    TextileTypePickerSimple,
    TextileModelPicker,
  },
  props: ['type'],
  data() {
    return {
      localType: this.type,
      model: null,
    }
  },
  computed: {
    editedCartItem() {
      return this.$store.state.cart.editedItem
    },
  },
  methods: {
    onModelPick(model) {
      this.model = model
      this.$emit('model-picked', { type: this.localType, model })
    },
    onTypeReset() {
      this.localType = null
    },
    onPickCancel() {
      this.$emit('cancel')
    }
  },
}
</script>

<style scoped>

</style>